import React from 'react';
import MaterialCircularProgress from '@material-ui/core/CircularProgress';

export default () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, height: '100vh' }}>
    <MaterialCircularProgress />
  </div>
);
